import { useState, type FormEvent } from 'react';
import { api, errorMessage } from './api';
import { Button, ErrorNotice } from './ui';

export function LoginPage({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [accessCode, setAccessCode] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!accessCode) return;
    setBusy(true);
    setError('');
    try {
      await api.login(accessCode, rememberMe);
      setAccessCode('');
      onAuthenticated();
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setBusy(false);
    }
  }

  return <main className="login-page">
    <section className="login-card" aria-labelledby="login-title">
      <div className="brand-mark" aria-hidden="true">ر</div>
      <p className="eyebrow">مرحبًا بك</p>
      <h1 id="login-title">ادخل إلى رامي</h1>
      <p className="muted">مساحتك الخاصة للحديث والذاكرة المستمرة.</p>
      {error ? <ErrorNotice message={error} /> : null}
      <form onSubmit={submit} className="form-stack">
        <label htmlFor="access-code">رمز الدخول</label>
        <input
          id="access-code"
          name="accessCode"
          type="password"
          minLength={15}
          maxLength={128}
          autoComplete="current-password"
          autoFocus
          required
          value={accessCode}
          onChange={(event) => setAccessCode(event.target.value)}
        />
        <label className="check-row">
          <input type="checkbox" checked={rememberMe} onChange={(event) => setRememberMe(event.target.checked)} />
          <span>تذكرني على هذا الجهاز لمدة تصل إلى 30 يومًا</span>
        </label>
        <Button type="submit" busy={busy} disabled={!accessCode}>{busy ? 'جارٍ التحقق' : 'دخول'}</Button>
      </form>
      <p className="privacy-note">لا نطلب اسم مستخدم أو بريدًا. رمزك لا يُعرض داخل التطبيق.</p>
    </section>
  </main>;
}
